import { Spinner } from 'reactstrap';
import usePdfReportLoadingOverlay from './usePdfReportLoadingOverlay';
// This selector's rules live in shared/ui's bundled Loadings stylesheet (global/unscoped SCSS,
// shared with loadingResetStudy.tsx) rather than moving with the component - see
// docs/project-structure.md's CSS-colocation precedent (Task 13b-6).
import '@/shared/ui/components/Loadings/styles.scss';

/**
 * Blocks the report while a clinic report is being regenerated after data changes. Returns null unless the overlay hook reports a clinic report in progress and no AI process is being stopped, otherwise renders a spinner with a regenerating notice.
 *
 * @returns The rendered regeneration overlay, or null when no clinic report is being regenerated.
 */
const PdfReportLoadingOverlay = () => {
  const { isClinicReport, isStoppingAiProcess } = usePdfReportLoadingOverlay();

  // Show overlay only when rendering clinic report (handles both initial render, socket updates, and API reloads)
  if (!isClinicReport || isStoppingAiProcess) {
    return null;
  }

  return (
    <div className="pdf-report-loading-overlay">
      <div className="pdf-report-loading-overlay-container">
        <Spinner className="pdf-report-loading-overlay__spinner">
          {/* eslint-disable-next-line react/jsx-curly-brace-presence -- must be a literal empty string, not omitted: reactstrap's Spinner defaultProps falls back to children="Loading..." when children is undefined */}
          {''}
        </Spinner>
        <div className="pdf-report-loading-overlay__generate-report">
          <div className="title">Regenerating report</div>
          <div className="sub-title">
            The report is being updated due to data changes.
            <br />
            This may take up to 10 minutes.
          </div>
        </div>
      </div>
    </div>
  );
};

export default PdfReportLoadingOverlay;
